/* Face Dunk bundle integrity, loaded on every page (moved from the product
   section so the cart page, cart drawer and all pages enforce it). */
(function(){
  /* ==========================================================
     FACE DUNK — CUSTOM BUNDLE PRICE / DISCOUNT INTEGRITY — V4 FAST
     A subscription bundle is valid only while its original
     paid-line count, paid quantities and gift quantities remain
     exactly intact. Any cart change that breaks that state turns
     the remaining paid products into one-time items and removes
     all gifts + the bundle discount.
     ========================================================== */
  if(window.__FD_CUSTOM_BUNDLE_PRICE_FIX_V4__)return;
  window.__FD_CUSTOM_BUNDLE_PRICE_FIX_V4__=true;

  var busy=false;
  var pending=false;
  var fallbackGiftUnits={'1':1,'2':2,'3':3};

  async function getCart(){
    try{
      var r=await fetch(window.Shopify.routes.root+'cart.js',{
        headers:{'Accept':'application/json'},
        cache:'no-store'
      });
      return r.ok?await r.json():null;
    }catch(e){return null;}
  }

  async function post(url,body){
    var r=await fetch(window.Shopify.routes.root+url,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    });
    if(!r.ok)throw new Error('Cart request failed');
    return r.json();
  }

  function num(v,fallback){
    var n=Number(v);
    return isFinite(n)?n:(fallback||0);
  }

  function isGift(item){
    return !!(item && item.properties && item.properties['_FD Gift']);
  }

  function bundleNumber(item){
    return String(item && item.properties && item.properties['_FD Bundle'] || '').trim();
  }

  function bundleId(item){
    return String(item && item.properties && item.properties['_FD Bundle ID'] || '').trim();
  }

  function expectedPaidQty(item){
    var p=item&&item.properties||{};
    var marked=num(p['_FD Bundle Qty'],0);
    return marked>0?marked:0;
  }

  function expectedGiftUnits(group,n){
    var marked=0;
    group.paid.forEach(function(item){
      var p=item.properties||{};
      var v=num(p['_FD Expected Gift Units'],0);
      if(v>0){marked=v;return;}
    });
    var bundleQty=1;
    group.paid.forEach(function(item){var q=num((item.properties||{})['_FD Bundle Qty'],0);if(q>0)bundleQty=q;});
    return marked>0?marked:(fallbackGiftUnits[n]||0)*bundleQty;
  }

  function buildGroups(c){
    var groups={};
    (c.items||[]).forEach(function(item){
      var n=bundleNumber(item);
      if(!n)return;
      /* Group by the per-add ID when present; older carts fall back to the pack size. */
      var id=bundleId(item),key=id?'id:'+id:'n:'+n;
      if(!groups[key])groups[key]={n:n,paid:[],gifts:[]};
      if(isGift(item))groups[key].gifts.push(item);
      else groups[key].paid.push(item);
    });
    return groups;
  }

  async function repair(c){
    if(busy){pending=true;return;}
    if(!c||!Array.isArray(c.items))return;

    var groups=buildGroups(c),broken=[];

    Object.keys(groups).forEach(function(n){
      var g=groups[n],expectedLines=Number(g.n);
      if(!expectedLines)return;

      /* Orphan gifts: no paid bundle products left. */
      if(g.paid.length===0 && g.gifts.length>0){
        broken.push(n);
        return;
      }

      if(g.paid.length===0)return;

      /* Only subscription bundles are subject to the intact-bundle test. */
      var hasSubscription=false,hasOneTime=false;
      g.paid.forEach(function(item){
        var type=String((item.properties||{})['_FD Purchase Type']||'').toLowerCase();
        if(type==='subscription')hasSubscription=true;
        if(type==='one-time')hasOneTime=true;
      });

      if(!hasSubscription && !hasOneTime)return;
      if(!hasSubscription)return;

      /* Mixed subscription/one-time lines = broken bundle. */
      if(hasOneTime || g.paid.length!==expectedLines){
        broken.push(n);
        return;
      }

      /* Quantity must still equal the quantity with which the bundle was added. */
      var quantityBroken=false;
      g.paid.forEach(function(item){
        var expectedQty=expectedPaidQty(item);
        if(expectedQty>0 && num(item.quantity,0)!==expectedQty)quantityBroken=true;
      });
      if(quantityBroken){
        broken.push(n);
        return;
      }

      /* Gifts must still have their complete original quantity. */
      var giftUnits=g.gifts.reduce(function(total,item){
        return total+num(item.quantity,0);
      },0);
      var expectedGifts=expectedGiftUnits(g,g.n);
      if(giftUnits!==expectedGifts){
        broken.push(n);
        return;
      }
    });

    if(!broken.length)return;

    busy=true;
    try{
      var remove=[],add=[];

      /* Lines the customer removed since this cart snapshot are neither removed (cart/update rejects unknown keys) nor re-added. */
      var live=await getCart(),liveKeys=null;
      if(live&&Array.isArray(live.items)){
        liveKeys={};
        live.items.forEach(function(item){liveKeys[item.key]=true;});
      }

      broken.forEach(function(n){
        var g=groups[n];

        g.paid.forEach(function(item){
          if(liveKeys&&!liveKeys[item.key])return;
          remove.push(item.key);

          var p=item.properties||{},np={};
          Object.keys(p).forEach(function(k){
            if(k==='_FD Purchase Type')return;
            if(k==='_FD Expected Gift Units')return;
            np[k]=p[k];
          });
          np['_FD Purchase Type']='One-time';

          /* IMPORTANT: no selling_plan is sent here. */
          add.push({
            id:Number(item.variant_id),
            quantity:num(item.quantity,1),
            properties:np
          });
        });

        g.gifts.forEach(function(item){
          if(liveKeys&&!liveKeys[item.key])return;
          remove.push(item.key);
        });
      });

      /* FAST PATH:
         Clear the cart-level gift discount AND remove every old bundle/gift
         line in ONE cart/update request. This keeps the V3 ordering that
         prevents the discount from leaking onto replacement paid products,
         but removes N separate cart/change requests. */
      var updates={};
      for(var i=0;i<remove.length;i++)updates[remove[i]]=0;
      await post('cart/update.js',{
        updates:updates,
        discount:''
      });

      /* Re-add the remaining paid products as normal one-time lines.
         No selling_plan is included, so the bundle is permanently broken
         after the user's quantity/gift/remove change. */
      if(add.length)await post('cart/add.js',{items:add});

      var fixed=await getCart();
      if(fixed){
        document.dispatchEvent(new CustomEvent('cart:refresh',{
          detail:{cart:fixed,fdBundleRepair:true}
        }));
        document.dispatchEvent(new CustomEvent('cart:updated',{
          detail:fixed
        }));
      }
    }catch(e){
      console.error('FACE DUNK bundle repair:',e);
    }finally{
      busy=false;
      /* A cart change arrived during the repair: check again once it is done. */
      if(pending){pending=false;schedule(null);}
    }
  }


  window.fdBundleRepairNow=async function(){
    var c=await getCart();
    if(c)await repair(c);
    return getCart();
  };
  var scheduleTimer=null;
  function schedule(detail){
    clearTimeout(scheduleTimer);
    scheduleTimer=setTimeout(function(){
      if(busy){pending=true;return;}
      if(detail&&detail.cart)repair(detail.cart);
      else getCart().then(function(c){if(c)repair(c);});
    },80);
  }

  document.addEventListener('cart:refresh',function(e){
    if(e&&e.detail&&e.detail.fdBundleRepair)return;
    schedule(e&&e.detail);
  });
  document.addEventListener('cart:change',function(){schedule(null);});
  document.addEventListener('cart:update',function(){schedule(null);});
  document.addEventListener('cart:updated',function(e){
    if(e&&e.detail&&e.detail.fdBundleRepair)return;
    schedule(e&&e.detail);
  });

  /* Catch Shopify cart changes even when the drawer/theme does not emit
     our custom events. This makes + / − / remove reliable. */
  if(!window.__FD_CART_FETCH_WATCH_V1__){
    window.__FD_CART_FETCH_WATCH_V1__=true;
    var fdOriginalFetch=window.fetch;
    window.fetch=function(input,init){
      var url='';
      try{url=typeof input==='string'?input:(input&&input.url)||'';}catch(e){}
      var isCartMutation=/\/cart\/(change|update|clear)\.js(?:[?#]|$)/.test(url);
      var result=fdOriginalFetch.apply(this,arguments);
      if(isCartMutation){
        result.then(function(){schedule(null);}).catch(function(){});
      }
      return result;
    };
  }
})();
